import React, { } from 'react'
import { useTranslation } from 'react-i18next'
import './Taiwan.less'
import { mapData, textData } from './DrawMap'

function Taiwan (props) {
  const { areaColorSetting: areaColorData, statistics, height, idKey, afterFix, valueObj = {}, reference } = props
  const { t: ln_t } = useTranslation()

  const handleMouseEnter = (element, area) => {
    if (element === 'text') {
      const g = document.getElementById(`${idKey}_${area}`)
      const hasClass = g && g.classList.contains('text-hover')
      if (g && !hasClass) g.classList.add('text-hover')
    }
    const text = document.getElementById(`${idKey}_${area}_text`)
    const allText = document.querySelectorAll(`.label.${idKey}`)
    const hasClass = text && text.classList.contains('text-show')
    if (allText && text && !hasClass) {
      allText.forEach(item => item.classList.add('text-hidden'))
      text.classList.remove('text-hidden')
      text.classList.add('text-show')
    }
  }

  const handleMouseLeave = (element, area) => {
    if (element === 'text') {
      const g = document.getElementById(`${idKey}_${area}`)
      const hasClass = g && g.classList.contains('text-hover')
      if (g && hasClass) g.classList.remove('text-hover')
    }
    const text = document.getElementById(`${idKey}_${area}_text`)
    const allText = document.querySelectorAll(`.label.${idKey}`)
    const hasClass = text && text.classList.contains('text-show')
    if (allText && text && hasClass) {
      allText.forEach(item => item.classList.remove('text-hidden'))
      text.classList.remove('text-show')
    }
  }

  const formatNumber = number => number ? String(Number(number).toFixed(2)) : number
  return !statistics
    ? ''
    : <svg className="taiwan" viewBox="0 0 850 1200" style={{ height }} ref={reference}>
        {Object.entries(mapData).map(([item, match]) => {
          const config = {}
          if (match.transform) config.transform = match.transform
          return (
            <g
              {...config}
              id={`${idKey}_${item}`}
              key={item}
              className={`area ${match.block && 'block'}`}
              onMouseEnter={() => handleMouseEnter('g', item)}
              onMouseLeave={() => handleMouseLeave('g', item)}
            >
              {match.layers
                ? match.data.map((layer, subIndex) => {
                  const innerConfig = {}
                  if (layer.transform) innerConfig.transform = layer.transform
                  const data = statistics[item]
                  return <g {...innerConfig} key={subIndex}>
                    {layer.path.map((path, thirdIndex) => <path d={path.d} fill={data && areaColorData[item] ? areaColorData[item] : '#cccccc'} key={`${item}_${thirdIndex}`} />)}
                  </g>
                })
                : match.path.map((path, subIndex) => <path d={path.d} fill={statistics[item] && areaColorData[item] ? areaColorData[item] : '#cccccc'} key={`${item}_${subIndex}`} />)}
            </g>)
        })}

        {Object.keys(statistics).filter(item => textData[item]).map((item, i) => {
          const match = textData[item] || {}
          const split = String(statistics[item]).split('.')
          let data = split[0]?.split('').reverse().map((item, index, array) => (index + 1) % 3 === 0 && index + 1 !== array.length ? `,${item}` : item).reverse().join('')
          if (split.length > 1) data = `${data}.${split[1]}`
          return <g key={item} id={`${idKey}_${item}_text`} className={`label ${idKey}`}>
            <text
              x={match.x}
              y={match.y}
              fill={i > 4 ? '#474e54' : 'black'}
              onMouseEnter={() => handleMouseEnter('text', item)}
              onMouseLeave={() => handleMouseLeave('text', item)}
            >
              {ln_t(`taiwan.city.${match.text}`)}
            </text>
            <text
                x={match.x}
                y={`${Number(match.y) - 30}`}
                fill={i > 4 ? '#474e54' : 'black'}
                onMouseEnter={() => handleMouseEnter('text', item)}
                onMouseLeave={() => handleMouseLeave('text', item)}
            >
              {afterFix === '%' ? formatNumber(statistics[item]) : data}
              {afterFix ? `${afterFix}` : ''}
            </text>
            <text
              x={match.x}
              y={`${Number(match.y) + 30}`}
              fill={i > 4 ? '#474e54' : 'black'}
              className='initial-text-hidden'
              onMouseEnter={() => handleMouseEnter('text', item)}
              onMouseLeave={() => handleMouseLeave('text', item)}
            >
              {valueObj[item] ? `${ln_t('dashboard.population')}: ${valueObj[item]}` : ''}
            </text>
          </g>
        })}

        {Object.keys(statistics).filter(item => !textData[item])?.splice(0, 2).map((item, i) => {
          const match = { text: item?.split('.')?.[2], x: '10', y: String(1050 - (i + 1) * 80) }
          const split = String(statistics[item]).split('.')
          let data = split[0]?.split('').reverse().map((item, index, array) => (index + 1) % 3 === 0 && index + 1 !== array.length ? `,${item}` : item).reverse().join('')
          if (split.length > 1) data = `${data}.${split[1]}`
          return <g key={item} id={`${idKey}_${item}_text`} className={`label ${idKey}`}>
            <text
              x={match.x}
              y={match.y}
              fill={i > 4 ? '#474e54' : 'black'}
              onMouseEnter={() => handleMouseEnter('text', item)}
              onMouseLeave={() => handleMouseLeave('text', item)}
            >
              {match.text}
            </text>
            <text
              x={match.x}
              y={`${Number(match.y) - 30}`}
              fill={i > 4 ? '#474e54' : 'black'}
              onMouseEnter={() => handleMouseEnter('text', item)}
              onMouseLeave={() => handleMouseLeave('text', item)}
            >
              {afterFix === '%' ? formatNumber(statistics[item]) : data}
              {afterFix ? `${afterFix}` : ''}
            </text>
            <text
              x={match.x}
              y={`${Number(match.y) + 30}`}
              fill={i > 4 ? '#474e54' : 'black'}
              className='initial-text-hidden'
              onMouseEnter={() => handleMouseEnter('text', item)}
              onMouseLeave={() => handleMouseLeave('text', item)}
            >
              {valueObj[item] ? `${ln_t('dashboard.population')}: ${valueObj[item]}` : ''}
            </text>
          </g>
        })}
      </svg>
}

export default Taiwan
